import "./assets/main.css";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { PiniaColada } from "@pinia/colada";

import App from "./App.vue";
import router from "./router";
import i18n, { initI18n } from "@/configs/i18n";
// Регистрирует перехватчик ошибок на голом инстансе Axios (401 -> логин)
import "@/configs/axios/interceptors";

import primevue from "@/primevue";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import ConfirmationService from "primevue/confirmationservice";
import { InitSentry } from "@/utils/sentry";
import { useAuthStore } from "@/stores/auth";
import { InitReserveRoutes } from "@/services/reserve/route";
import { InitAttestationRoutes } from "@/services/attestations/route";
import { InitRatingRoutes } from "@/services/rating/route";
import { InitDigitalCompetencyRoutes } from "@/services/digital-competency/route";
import Ripple from "primevue/ripple";
import { piniaColadaOptions } from "@/configs/pinia-colada";
import ky from "@/configs/primevue-locales/ky.json";
import ru from "@/configs/primevue-locales/ru.json";
import { InitPanelHeaderToggle } from "@/utils/panelHeaderToggle";
import { InitConfirmPopupTarget } from "@/utils/confirmPopupTarget";

const pinia = createPinia();

window.locales = {
  ky,
  ru,
};

const app = createApp(App);

app
  .use(primevue, {
    ripple: true,
    locale: window.locales[localStorage.getItem("locale") ?? "ky"],
  })
  .use(ToastService)
  .directive("ripple", Ripple);

app.use(pinia);
app.use(PiniaColada, piniaColadaOptions);
// vue3-apexcharts больше не регистрируется глобально: библиотека весит около
// половины входного бандла и загружалась на каждой странице, включая логин.
// Графики импортируют её сами — она попадает в чанки своих маршрутов.
app.use(i18n);
initI18n();

app.directive("tooltip", Tooltip);

app.use(ConfirmationService);
// окно подтверждения выравнивается по кнопке, а не по левому верхнему углу
InitConfirmPopupTarget(app);

// Сворачиваемые панели раскрываются щелчком по всему заголовку, а не только по шеврону
InitPanelHeaderToggle();

if (import.meta.env.VITE_SENTRY_ENABLE) {
  InitSentry();
}

// Порядок важен: сначала пользователь, затем маршруты (digital-competency
// дописывается в группу, созданную аттестациями). Каждый шаг изолирован —
// нехватка прав или недоступный эндпоинт не должны отменять остальные.
async function preRequests() {
  const steps = [
    ["auth", () => useAuthStore().initApp()],
    ["reserve routes", InitReserveRoutes],
    ["attestation routes", InitAttestationRoutes],
    ["rating routes", InitRatingRoutes],
    ["digital competency routes", InitDigitalCompetencyRoutes],
  ];

  for (const [name, step] of steps) {
    try {
      await step();
    } catch (e) {
      console.error(`[boot] шаг "${name}" завершился с ошибкой`, e);
    }
  }
}

preRequests().finally(() => {
  app.use(router).mount("#app");
});
